import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import BackAbroadOrderList from '../entities/order-back-list'

interface BackAbroadOrderState extends ListState<BackAbroadOrderList> {

}

class BackAbroadOrderMutations extends ListMutations<BackAbroadOrderList>{

}
class BackAbroadOrder extends ListModule<BackAbroadOrderState, any, BackAbroadOrderList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BackAbroadOrderList>(),
        loading: false,
        updateOrdeData: null,
        ids: [],
        BaseSkuNums: 0,
        ordertype: 0,
        id: 0
    }
    actions = {
        async getAll(context: ActionContext<BackAbroadOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/YNRefusalOrder/GetOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<BackAbroadOrderList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async handleStatus(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/YNRefusalOrder/HandleStatus', payload.data);
        },
        async againhandleStatus(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/YNRefusalOrder/AgainHandleStatus', payload.data);
        },
        async impotExcel(state: any, payload: any) {
            Ajax.get('/api/File/GetExcelExportYNRefusalOrderInfo', { params: payload.data, responseType: "blob" }).then(res => {
                const content = res.data;
                const blob = new Blob([content]);
                const fileName = '云南拒收订单信息.xlsx'
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                } else { // IE10+下载
                  //  navigator.msSaveBlob(blob, fileName)
                }
            });
        },
    };
    mutations = {
        setCurrentPage(state: BackAbroadOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackAbroadOrderState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const BackAbroadOrderlist = new BackAbroadOrder();
export default BackAbroadOrderlist;